export default "__VITE_ASSET__8331ea29__"